<template>
  <div>
    <div class="fapiaoqq" ref="fapiao2">
      <div class="zziiz">发票查询</div>
      <div class="tips">
        温馨提示：<br />
        1、普票和专票均为数电电子发票，以手机短信或者邮箱为准（诺诺网发送）。<br />
        2、如需重开发票，请将姓名、联系方式、具体的需求和原发票发送至邮箱zjfzfwzx@163.com 。
      </div>
      <div class="danzi">
        <Table :columns="columns" :data="data">
          <template slot-scope="{ row }" slot="action">
            <div>
              <span
                class="bianji"
                ref="ck"
                :style="{ color: row.invoiceType == 1 ? 'rgba(53, 98, 232, 1)' : '' }"
                @click="chakan(row.id, row.invoiceStatus)"
                >查看详情</span
              >
            </div>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>
<script>
import { queryOrderInvoice } from "network/home";

export default {
  data() {
    return {
      leixing: "",
      data: [],

      columns: [
        {
          title: "发票抬头",
          key: "invoiceRise",
          align: "center",
        },
        {
          title: "发票类型",
          key: "invoiceType",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#676767",
                  },
                },
                params.row.invoiceType === 1
                  ? "普通发票"
                  : params.row.invoiceType === 2
                  ? "专业发票"
                  : ""
              ),
            ]);
          },
        },
        {
          title: "发票金额",
          align: "center",
          key: "totalFee",
        },
        {
          title: "开票状态",
          key: "invoiceStatus",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#676767",
                  },
                },
                params.row.invoiceStatus === 0
                  ? "开票中"
                  : params.row.invoiceStatus === 1
                  ? "开票成功"
                  : params.row.invoiceStatus === 2
                  ? "开票失败"
                  : params.row.invoiceStatus === 3
                  ? "未开票"
                  : params.row.invoiceStatus === 4
                  ? "已退订"
                  : ""
              ),
            ]);
          },
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
    };
  },
  created() {
    this.queryOrderInvoice();
    this.$emit("editPage", "发票查询", "发票查询");
  },
  activated() {
    this.$emit("editPage", "发票查询", "发票查询");
  },
  methods: {
    // 发票查询
    queryOrderInvoice() {
      queryOrderInvoice().then((res) => {
        console.log(res, "发票");
        this.data = res.data.data;
      });
    },

    //发票详情
    chakan(id, leixing) {
      console.log(id, leixing);
      if (leixing == 0) {
        this.$message({
          message: "开票中",
          type: "warning",
        });
      } else if (leixing == 1) {
        this.$router.push({
          name: "fapiao",
          query: {
            id: id,
          },
        });
      } else if (leixing == 2) {
        this.$message({
          message: "开票失败",
          type: "warning",
        });
      } else if (leixing == 3) {
        this.$message({
          message: "未开票",
          type: "warning",
        });
      } else if (leixing == 4) {
        this.$message({
          message: "已退订",
          type: "warning",
        });
      }
    },
  },
};
</script>
<style scoped>
.fapiaoqq {
  width: 900px;
  height: 800px;
  margin-left: -25px;
}
.bianji{
  text-decoration:underline;
  color: rgba(53, 98, 232, 1);
  font-weight: 500;
}
.zziiz {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #4771ea;
  margin-top: 30px;
  margin-left: 14px;
  margin-bottom: 10px;
}
.danzi {
  width: 900px;
  height: 800px;
  overflow-y: auto;
}
.tips {
  margin-left: 14px;
  margin-bottom: 24px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000;
  line-height: 24px;
}
</style>
<style>
.ivu-table-header thead tr th {
  background-color: rgba(244, 247, 255, 1);
  border-color: rgba(71, 113, 234, 0.1) !important;
}
</style>